<template>
    <div class="x-navbar-link" style="position: relative">
        <a href="javascript:;"
           class="nav-icon-link double-horizontal-padding"
           :class="buttonClass()"
           @click="showDropdown()"
           aria-label="Tarefas"
           title="Tarefas"
           v-el:anchor>
            <i class="fa fa-tasks x-navbar-icon"></i>
            <div v-if="hasNew"
                 class="bg-red dropdown-tasks-notification-icon"
                 style="position: absolute; z-index: 1; top: 10px; right: 0; border-radius: 100%; font-size: 10px; width: 16px; height: 16px; display: flex; justify-content: center; line-height: 16px;">
                <span v-if="hasNew > 9">9+</span>
                <span v-if="hasNew <= 9">{{ hasNew }}</span>
            </div>

            <div v-if="hasDone && !hasRunning"
                 class="bg-green font-white dropdown-tasks-notification-icon"
                 style="position: absolute; z-index: 1; bottom: 10px; right: 0; border-radius: 100%; font-size: 10px; width: 16px; height: 16px; display: flex; justify-content: center; line-height: 16px;">
                <i class="fa fa-check"></i>
            </div>

            <div v-if="hasRunning"
                 class="has-running-spin  dropdown-tasks-notification-icon">
                <i class="fa fa-gear"></i>
            </div>
        </a>
        <tasks-dropdown v-ref:dropdown
                        :visibility-changed="dropdownVisibilityChanged"
                        :has-new-changed="updateHasNew"
                        :has-new-done="updateHasDone"
                        :has-new-running="updateHasRunning"
        ></tasks-dropdown>
    </div>
</template>
<style scoped>
    .dropdown-tasks-notification-icon {
        pointer-events: none;
    }

    .has-running-spin {
        animation-name: has-running-spin;
        animation-duration: 1500ms;
        animation-iteration-count: infinite;
        animation-timing-function: linear;
        background-color: #333;
        color: white;
        position: absolute;
        z-index: 1;
        bottom: 10px;
        right: 0;
        border-radius: 100%;
        font-size: 10px;
        width: 16px;
        height: 16px;
        display: flex;
        justify-content: center;
        line-height: 16px;
        padding-top: 1px;
    }

    @keyframes has-running-spin {
        from {
            transform:rotate(0deg);
        }
        to {
            transform:rotate(360deg);
        }
    }

    .nav-icon-link.pressed {
        background-color: rgba(255, 255, 255, .12);
    }
</style>
<script>
    const TasksDropdown = require('./Dropdown.vue')

    export default {
        name: 'NavbarTasks',
        components: {TasksDropdown},
        data() {
            return {
                dropdownVisible: false,
                hasNew: false,
                hasDone: false,
                hasRunning: false
            }
        },
        ready() {
        },
        methods: {
            buttonClass() {
                return {
                    pressed: this.dropdownVisible
                }
            },
            dropdownVisibilityChanged(state) {
                this.hasDone = false
                this.hasRunning = false
                this.dropdownVisible = state
            },
            showDropdown() {
                this.$refs.dropdown.show(this.$els.anchor)
            },
            updateHasNew(state) {
                this.hasNew = state
            },
            updateHasDone() {
                this.hasRunning = false
                this.hasDone = true
            },
            updateHasRunning() {
                this.hasDone = false
                this.hasRunning = true
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Navbar.vue?007f394e